import { API_BASE_URL, ENABLE_AUTH } from '../utils/constants';

async function parseJsonSafe(response) {
  try {
    return await response.json();
  } catch (_error) {
    return null;
  }
}

function buildError(payload, fallbackMessage) {
  const error = new Error(
    payload?.error?.message || payload?.message || fallbackMessage || 'Request failed.'
  );
  error.code = payload?.error?.code || 'REQUEST_FAILED';
  error.payload = payload;
  return error;
}

async function requestJson(path, { method = 'GET', body, clerkToken } = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      ...(clerkToken ? { Authorization: `Bearer ${clerkToken}` } : {}),
      'Content-Type': 'application/json',
    },
    credentials: ENABLE_AUTH ? 'include' : 'omit',
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  const payload = await parseJsonSafe(response);
  if (!response.ok) {
    throw buildError(payload, 'Request failed.');
  }

  return payload?.data || payload || {};
}

export function exchangeWorkspaceClerkSession({ clerkToken, tenantId }) {
  return requestJson('/auth/web/clerk/exchange', {
    method: 'POST',
    clerkToken,
    body: tenantId ? { tenantId } : {},
  });
}

export function fetchWorkspaceWebSession() {
  return requestJson('/auth/web/session', { method: 'GET' });
}

export function loginWorkspaceNativeSession(payload = {}) {
  return requestJson('/auth/native/login', {
    method: 'POST',
    body: payload,
  });
}

export function exchangeWorkspaceNativeClerkSession({ clerkToken, tenantId }) {
  return requestJson('/auth/native/clerk/exchange', {
    method: 'POST',
    clerkToken,
    body: tenantId ? { tenantId } : {},
  });
}

export function refreshWorkspaceNativeSession({ refreshToken }) {
  return requestJson('/auth/native/refresh', {
    method: 'POST',
    body: refreshToken ? { refreshToken } : {},
  });
}

export function logoutWorkspaceNativeSession({ refreshToken }) {
  return requestJson('/auth/native/logout', {
    method: 'POST',
    body: refreshToken ? { refreshToken } : {},
  });
}

export function logoutWorkspaceWebSession() {
  return requestJson('/auth/web/logout', {
    method: 'POST',
    body: {},
  });
}

export function exchangeAdminClerkSession({ clerkToken }) {
  return requestJson('/admin-auth/web/clerk/exchange', {
    method: 'POST',
    clerkToken,
    body: {},
  });
}

export function fetchAdminWebSession() {
  return requestJson('/admin-auth/web/session', { method: 'GET' });
}

export function logoutAdminWebSession() {
  return requestJson('/admin-auth/web/logout', {
    method: 'POST',
    body: {},
  });
}
